<template>
  <component :is="currentComponent" v-bind="compProps"></component>
</template>

<script>
import RewardCatalog from '../../components/client/redeemPoints/RewardCatalog'
import RewardDetail from '../../components/client/redeemPoints/RewardDetail'
import CartItems from '../../components/client/redeemPoints/CartItems'
import { mapActions } from 'vuex'

export default {
  name: 'RedeemPoints',
  props: ['initComponent'],
  components: {
    'reward-catalog': RewardCatalog,
    'reward-detail': RewardDetail,
    'cart-items': CartItems
  },
  created () {
    this.$bus.on('swapComponent', this.swapComponent)
    this.$bus.on('reloadComponent', this.reloadComponent)
  },
  beforeDestroy () {
    this.$bus.off('swapComponent', this.swapComponent)
    this.$bus.off('reloadComponent', this.reloadComponent)
  },
  mounted () {
    this.currentComponent = this.initComponent || 'reward-catalog'
    Promise.all([
      this.getLoyaltyProgramBySlug(this.slug),
      this.getUser()
    ])
  },
  data () {
    return {
      updateKey: 'test',
      currentComponent: '',
      compProps: [],
      slug: this.$route.params.slug
    }
  },
  methods: {
    ...mapActions('loyaltyProgram', [ 'getLoyaltyProgramBySlug' ]),
    ...mapActions('user', [ 'getUser' ]),
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    swapComponent (component) {
      this.scrollToTop()
      this.currentComponent = component.component
      if (component.props) {
        this.compProps = component.props
      } else {
        this.compProps = {}
      }
    },
    reloadComponent (payload) {
      this.currentComponent = payload.comp
      this.$forceUpdate()
    }
  }
}
</script>
